function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1794_98)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.4916 8.14968C16.4916 7.49417 16.4371 7.01582 16.3193 6.51976H8.65936V9.47841H13.1556C13.065 10.2137 12.5755 11.321 11.4876 12.065L11.4724 12.1641L13.8943 13.9976L14.0621 14.0139C15.6031 12.6231 16.4916 10.5769 16.4916 8.14968",
  fill: "#15A9E1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.65933 15.945C10.8621 15.945 12.7113 15.2363 14.0621 14.0139L11.4876 12.065C10.7987 12.5345 9.87402 12.8623 8.65933 12.8623C6.50187 12.8623 4.67075 11.4716 4.01801 9.54931L3.92233 9.55725L1.40397 11.4618L1.37103 11.5513C2.71264 14.1556 5.46842 15.945 8.65933 15.945Z",
  fill: "#34A853"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.01805 9.54931C3.84582 9.05325 3.74614 8.52171 3.74614 7.97252C3.74614 7.42327 3.84582 6.89179 4.00899 6.39573L4.00442 6.29008L1.4545 4.35493L1.37108 4.39371C0.818134 5.47444 0.500854 6.68806 0.500854 7.97252C0.500854 9.25698 0.818134 10.4705 1.37108 11.5513L4.01805 9.54931",
  fill: "#FBBC05"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.65933 3.08269C10.1913 3.08269 11.2247 3.72935 11.8139 4.26975L14.1165 2.07286C12.7023 0.788398 10.8621 0 8.65933 0C5.46842 0 2.71264 1.78938 1.37103 4.39372L4.00895 6.39574C4.67075 4.47347 6.50187 3.08269 8.65933 3.08269",
  fill: "#EB4335"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1794_98"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white",
  transform: "translate(0.5)"
})));

var SvgGoogleColour = function SvgGoogleColour(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoogleColour, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/google-colour.8a5975b2.svg";
export { ForwardRef as ReactComponent };